import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Pages.css';

const Terms = () => {
  return (
    <div className="page-container">
      <Header scrolled={true} />
      
      <main className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1>Términos de Servicio</h1>
            <p>Última actualización: 1 de Junio, 2023</p>
          </div>
        </section>
        
        <section className="page-section">
          <div className="container">
            <div className="legal-content">
              <div className="legal-section">
                <h2>1. Introducción</h2>
                <p>Estos Términos de Servicio ("Términos") rigen su acceso y uso de los servicios, aplicaciones y productos de VillaTracking (colectivamente, los "Servicios").</p>
                <p>Al acceder o utilizar nuestros Servicios, usted acepta estar sujeto a estos Términos. Si no está de acuerdo con estos Términos, no debe acceder ni utilizar nuestros Servicios.</p>
              </div>
              
              <div className="legal-section">
                <h2>2. Descripción del Servicio</h2>
                <p>VillaTracking proporciona servicios de rastreo y gestión de flotas vehiculares a través de dispositivos GPS, una plataforma web y aplicaciones móviles. Nuestros Servicios permiten a los usuarios monitorear la ubicación, velocidad y estado de sus vehículos, generar informes, recibir alertas y gestionar diversos aspectos de su flota.</p>
              </div>
              
              <div className="legal-section">
                <h2>3. Cuenta de Usuario</h2>
                <p>Para utilizar nuestros Servicios, debe crear una cuenta. Usted es responsable de mantener la confidencialidad de su información de cuenta y contraseña, y de restringir el acceso a su cuenta. Usted acepta la responsabilidad por todas las actividades que ocurran bajo su cuenta.</p>
                <p>VillaTracking se reserva el derecho de rechazar el servicio, cerrar cuentas, eliminar o editar contenido, o cancelar pedidos a su entera discreción.</p>
              </div>
              
              <div className="legal-section">
                <h2>4. Privacidad</h2>
                <p>Nuestra Política de Privacidad describe cómo recopilamos, utilizamos y compartimos su información personal. Al utilizar nuestros Servicios, usted acepta nuestras prácticas de privacidad como se describe en nuestra Política de Privacidad.</p>
              </div>
              
              <div className="legal-section">
                <h2>5. Licencia y Restricciones</h2>
                <p>VillaTracking le otorga una licencia limitada, no exclusiva, no transferible y revocable para utilizar nuestros Servicios de acuerdo con estos Términos. Usted no puede:</p>
                <ul>
                  <li>Utilizar nuestros Servicios para fines ilegales o no autorizados</li>
                  <li>Copiar, modificar, distribuir, vender o arrendar cualquier parte de nuestros Servicios</li>
                  <li>Realizar ingeniería inversa o intentar extraer el código fuente de nuestro software</li>
                  <li>Utilizar nuestros Servicios de manera que pueda dañar, deshabilitar, sobrecargar o deteriorar nuestros sistemas</li>
                  <li>Acceder a nuestros Servicios mediante métodos automatizados</li>
                </ul>
              </div>
              
              <div className="legal-section">
                <h2>6. Propiedad Intelectual</h2>
                <p>Todos los derechos de propiedad intelectual relacionados con nuestros Servicios son propiedad de VillaTracking o sus licenciantes. Estos Términos no le otorgan ningún derecho, título o interés en nuestros Servicios, contenido, logotipos, marcas comerciales o cualquier otra propiedad intelectual.</p>
              </div>
              
              <div className="legal-section">
                <h2>7. Facturación y Pagos</h2>
                <p>Los precios y planes de suscripción están disponibles en nuestro sitio web. VillaTracking se reserva el derecho de cambiar los precios de los Servicios en cualquier momento. Cualquier cambio en los precios entrará en vigor al comienzo del siguiente período de facturación.</p>
                <p>Usted es responsable de pagar todas las tarifas asociadas con su cuenta. Si no pagamos recibimos su pago, podemos suspender o cancelar su acceso a nuestros Servicios.</p>
              </div>
              
              <div className="legal-section">
                <h2>8. Cancelación y Terminación</h2>
                <p>Puede cancelar su suscripción en cualquier momento. La cancelación será efectiva al final del período de facturación actual.</p>
                <p>VillaTracking puede terminar o suspender su acceso a nuestros Servicios inmediatamente, sin previo aviso ni responsabilidad, por cualquier motivo, incluyendo, sin limitación, si usted incumple estos Términos.</p>
              </div>
              
              <div className="legal-section">
                <h2>9. Limitación de Responsabilidad</h2>
                <p>En la medida máxima permitida por la ley aplicable, VillaTracking no será responsable por daños indirectos, incidentales, especiales, consecuentes o punitivos, o cualquier pérdida de beneficios o ingresos, ya sea incurrida directa o indirectamente, o cualquier pérdida de datos, uso, buena voluntad, u otras pérdidas intangibles, resultantes de:</p>
                <ul>
                  <li>Su acceso o uso o incapacidad para acceder o usar los Servicios</li>
                  <li>Cualquier conducta o contenido de terceros en los Servicios</li>
                  <li>Acceso no autorizado, uso o alteración de sus transmisiones o contenido</li>
                </ul>
              </div>
              
              <div className="legal-section">
                <h2>10. Cambios en los Términos</h2>
                <p>VillaTracking se reserva el derecho de modificar estos Términos en cualquier momento. Le notificaremos sobre cualquier cambio publicando los nuevos Términos en nuestro sitio web o a través de otros canales de comunicación. Los cambios entrarán en vigor inmediatamente después de su publicación.</p>
                <p>Su uso continuado de nuestros Servicios después de la publicación de los Términos modificados constituye su aceptación de los mismos.</p>
              </div>
              
              <div className="legal-section">
                <h2>11. Ley Aplicable</h2>
                <p>Estos Términos se regirán e interpretarán de acuerdo con las leyes de Venezuela, sin tener en cuenta sus disposiciones sobre conflictos de leyes.</p>
              </div>
              
              <div className="legal-section">
                <h2>12. Contacto</h2>
                <p>Si tiene alguna pregunta sobre estos Términos, por favor contáctenos a:</p>
                <p>Email: soporte@villatracking.com</p>
                <p>Dirección: Los Laureles, Cabimas 4013, Estado Zulia, Venezuela</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Terms;